import { getInterceptorMinuta } from 'app/utils/logs/minuta/Minuta.log';
import * as auth from '../../app/modules/auth/redux/AuthRedux'
import { warn, error } from '../../app/utils/customToasd';



export default function SetupAxios(axios: any, store: any, dispatch: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.defaults.headers.common['Content-Type'] = 'application/json'
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*' // for all requests
  
  // Timeouts configurables según tipo de operación
  const TIMEOUTS = {
    DEFAULT: 3000000,        // 30 segundos para operaciones normales
    LONG_OPERATION: 5000000, // 2 minutos para operaciones que pueden tardar más
    VERY_LONG: 10000000,     // 5 minutos para operaciones muy pesadas (crear minutas grandes)
  }

  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: { accessToken },
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
        config.headers.token = `${accessToken}`
      }

      // Configurar timeout según el tipo de operación si no se especificó uno
      if (!config.timeout) {
        const operationName = config.data?.name || ''
        const url = config.url || ''
        
        // Operaciones que pueden tardar mucho tiempo
        const isVeryLongOperation = 
          operationName === 'amd_createMinuta' ||
          operationName === 'amd_replicarMinutaRotativa' ||
          operationName === 'amd_replicarMinutaFija' ||
          operationName === 'amd_restribucionHomologada' ||
          url.includes('Runhomologado') ||
          url.includes('Runcombinado')
        
        // Operaciones que pueden tardar un tiempo moderado
        const isLongOperation = 
          operationName === 'amd_replicarMinutaSeguidor' ||
          url.includes('Runminuta') ||
          url.includes('Runplantilla')
        
        if (isVeryLongOperation) {
          config.timeout = TIMEOUTS.VERY_LONG
        } else if (isLongOperation) {
          config.timeout = TIMEOUTS.LONG_OPERATION
        } else {
          config.timeout = TIMEOUTS.DEFAULT
        }
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => {
      if (response.data.status == '401') {
        localStorage.clear()
        warn('Sesión expirada!!')
        dispatch(auth.actions.logout())
        return Promise.reject(response)
      }

      if (response.data.status == '403') {
        error(`Error: ${response.data.result}`)
        return Promise.reject(response)
      }

      if (response.data.status == '200') {
        getInterceptorMinuta(response)
      }
      return response
    },
    (err: any) => {
      // Detección robusta de errores de timeout
      const isTimeoutError = 
        err.code === 'ECONNABORTED' || 
        err.message?.toLowerCase().includes('timeout') ||
        err.message?.toLowerCase().includes('exceeded') ||
        (err.response?.status === 408) ||
        (err.response?.statusText?.toLowerCase().includes('timeout'))

      if (isTimeoutError) {
        const operationName = err.config?.data?.name || err.config?.url || 'la operación'
        const timeoutMs = err.config?.timeout || TIMEOUTS.DEFAULT
        const timeoutSeconds = Math.round(timeoutMs / 1000)
        
        // Mensajes específicos según el tipo de operación
        if (operationName === 'amd_createMinuta' || operationName.includes('createMinuta')) {
          error(`La creación de la minuta está tardando más de ${timeoutSeconds} segundos. Esto puede deberse a una gran cantidad de datos. Por favor, espere un momento e intente nuevamente.`, 'bottom-center')
        } else if (operationName.includes('replicar') || operationName.includes('homolog')) {
          error(`La operación de replicación está tardando más de ${timeoutSeconds} segundos. Por favor, espere un momento e intente nuevamente.`, 'bottom-center')
        } else {
          error(`La solicitud tardó demasiado tiempo (${timeoutSeconds}s). Por favor, verifique su conexión e intente nuevamente.`, 'bottom-center')
        }
      } else if (err.response) {
        // Error de respuesta del servidor
        const status = err.response.status
        const message = err.response.data?.result || err.response.data?.message || err.message
        
        if (status >= 500) {
          error(`Error del servidor (${status}). Por favor, intente nuevamente más tarde.`, 'bottom-center')
        } else if (status === 404) {
          error(`Recurso no encontrado. Por favor, verifique los datos e intente nuevamente.`, 'bottom-center')
        } else if (status === 401) {
          // Ya se maneja arriba, pero por si acaso
          return Promise.reject(err)
        } else {
          error(typeof message === 'string' ? message : `Error en la solicitud (${status})`, 'bottom-center')
        }
      } else if (err.request) {
        // Error de red (sin respuesta del servidor)
        error('No se pudo conectar con el servidor. Por favor, verifique su conexión a internet e intente nuevamente.', 'bottom-center')
      } else {
        // Otro tipo de error
        error(err.message || 'Ocurrió un error inesperado. Por favor, intente nuevamente.', 'bottom-center')
      }

      return Promise.reject(err)
    }
  )

}
